var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSpinner08S50Px = function SvgSpinner08S50Px(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      margin: "auto",
      background: "0 0",
      display: "block",
      shapeRendering: "auto"
    },
    width: 50,
    height: 50,
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 44.5,
    y: 13.5,
    rx: 5.5,
    ry: 5.5,
    width: 11,
    height: 11,
    fill: "#005db5"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.819672131147541s",
    begin: "-0.7513661202185792s",
    repeatCount: "indefinite"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 44.5,
    y: 13.5,
    rx: 5.5,
    ry: 5.5,
    width: 11,
    height: 11,
    fill: "#005db5",
    transform: "rotate(30 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.819672131147541s",
    begin: "-0.6830601092896175s",
    repeatCount: "indefinite"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 44.5,
    y: 13.5,
    rx: 5.5,
    ry: 5.5,
    width: 11,
    height: 11,
    fill: "#005db5",
    transform: "rotate(60 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.819672131147541s",
    begin: "-0.6147540983606558s",
    repeatCount: "indefinite"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 44.5,
    y: 13.5,
    rx: 5.5,
    ry: 5.5,
    width: 11,
    height: 11,
    fill: "#005db5",
    transform: "rotate(90 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.819672131147541s",
    begin: "-0.5464480874316939s",
    repeatCount: "indefinite"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 44.5,
    y: 13.5,
    rx: 5.5,
    ry: 5.5,
    width: 11,
    height: 11,
    fill: "#005db5",
    transform: "rotate(120 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.819672131147541s",
    begin: "-0.4781420765027322s",
    repeatCount: "indefinite"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 44.5,
    y: 13.5,
    rx: 5.5,
    ry: 5.5,
    width: 11,
    height: 11,
    fill: "#005db5",
    transform: "rotate(150 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.819672131147541s",
    begin: "-0.4098360655737705s",
    repeatCount: "indefinite"
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 44.5,
    y: 13.5,
    rx: 5.5,
    ry: 5.5,
    width: 11,
    height: 11,
    fill: "#005db5",
    transform: "rotate(180 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.819672131147541s",
    begin: "-0.34153005464480873s",
    repeatCount: "indefinite"
  }))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 44.5,
    y: 13.5,
    rx: 5.5,
    ry: 5.5,
    width: 11,
    height: 11,
    fill: "#005db5",
    transform: "rotate(210 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.819672131147541s",
    begin: "-0.27322404371584696s",
    repeatCount: "indefinite"
  }))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 44.5,
    y: 13.5,
    rx: 5.5,
    ry: 5.5,
    width: 11,
    height: 11,
    fill: "#005db5",
    transform: "rotate(240 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.819672131147541s",
    begin: "-0.20491803278688525s",
    repeatCount: "indefinite"
  }))), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 44.5,
    y: 13.5,
    rx: 5.5,
    ry: 5.5,
    width: 11,
    height: 11,
    fill: "#005db5",
    transform: "rotate(270 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.819672131147541s",
    begin: "-0.13661202185792348s",
    repeatCount: "indefinite"
  }))), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 44.5,
    y: 13.5,
    rx: 5.5,
    ry: 5.5,
    width: 11,
    height: 11,
    fill: "#005db5",
    transform: "rotate(300 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.819672131147541s",
    begin: "-0.06830601092896174s",
    repeatCount: "indefinite"
  }))), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 44.5,
    y: 13.5,
    rx: 5.5,
    ry: 5.5,
    width: 11,
    height: 11,
    fill: "#005db5",
    transform: "rotate(330 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.819672131147541s",
    begin: "0s",
    repeatCount: "indefinite"
  }))));
};

export { SvgSpinner08S50Px as ReactComponent };
export default "data:image/svg+xml;base64,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";